import { useCallback } from 'react';

const REACT_APP_COGNITO_DOMAIN = window.REACT_APP_COGNITO_DOMAIN || import.meta.env.REACT_APP_COGNITO_DOMAIN;
const REACT_APP_SSO_CLIENT_ID = window.REACT_APP_SSO_CLIENT_ID || import.meta.env.REACT_APP_SSO_CLIENT_ID;

const useAwsAmplifyLogout = () => {
  const awsAmplifyLogout = useCallback(() => {
    const baseUrl = `${window.location.protocol}//${window.location.host}`;
    const logoutUrl = `${REACT_APP_COGNITO_DOMAIN}/logout?client_id=${REACT_APP_SSO_CLIENT_ID}&logout_uri=${baseUrl}/signout`;
    window.location.href = logoutUrl;
  }, []);

  return {
    awsAmplifyLogout,
  };
};

export default useAwsAmplifyLogout;
